import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import ButtonFavorite from './ButtonFavorite';

function ConnectedRow({
  name, onClickTo, isFavorite = false, onClickFavorite, isSelected, style,
  isConnected, showIconFav = true
}) {
  return (
    <span className={`type-medium fz14 genre-row ${isSelected && `selected`}`} style={{ ...style }}>
      <span onClick={onClickTo} className={`genre-link ${isSelected && `selected`}`}>
        {name}
      </span>
      { (isConnected && showIconFav) && <ButtonFavorite className={`icon-star ${isFavorite && `favorite`}`} color={'#B3B3B3'} size={17} active={isFavorite} onClick={onClickFavorite} /> }
    </span>
  )
}

ConnectedRow.propTypes = {
  name: PropTypes.string.isRequired,
  to: PropTypes.string,
  onClickTo: PropTypes.func,
  isFavorite: PropTypes.bool,
  onClickFavorite: PropTypes.func,
  isSelected: PropTypes.bool.isRequired,
  showIconFav: PropTypes.bool,
  style: PropTypes.object,
}

const Row = connect(
  state => ({
    isConnected: state.isConnected
  })
)(ConnectedRow);

export default Row;
